import { IChatConfigData, Locale } from '../../../types/app-interfaces';

const prodConfigData: Record<Locale, IChatConfigData> = {
  'en-us': {
    locale: 'en-us',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com/',
      eswConfigDevName: 'ChatAnywhere_MIAW_EN_US_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENU1756112545869',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENU1756112545869/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fvan',
        checkout: '00G07000000i3PW',
        design: '00G1v000005kYqQ',
        digital: '00G0Y000004z7MW',
        msp: '00G07000000h1jl',
        ppag: '00G1v000005KMQv',
        wedding: '00G07000000qlo6',
      },
    },
  },
  'da-dk': {
    locale: 'da-dk',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_DK_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWDKC1747766195331',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWDKC1747766195331/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G1v000007kdRE',
        checkout: '00G07000000F1Rg',
        design: '00G07000000hYBO',
        digital: '00G1v000007kdRE',
      },
    },
  },
  'de-at': {
    locale: 'de-at',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_DE_AT_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWDEA1749560749763',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWDEA1749560749763/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxEn',
        checkout: '00G07000000F1Rd',
        design: '00G07000000hEyf',
        digital: '00G41000000fxEn',
      },
    },
  },
  'de-ch': {
    locale: 'de-ch',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_DE_CH_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWDEC1749561242330',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWDEC1749561242330/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxEx',
        checkout: '00G07000000F1Re',
        design: '00G07000000hEyg',
        digital: '00G41000000fxEx',
      },
    },
  },
  'de-de': {
    locale: 'de-de',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_DE_DE_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWDED1749489112047',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWDED1749489112047/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxEi',
        checkout: '00G07000000F1Rf',
        design: '00G1v000006WqQ7',
        digital: '00G41000000fxEi',
      },
    },
  },
  'en-au': {
    locale: 'en-au',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_EN_AU_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENA1745858559505',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENA1745858559505/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxEd',
        checkout: '00G07000000F1Rh',
        design: '00G1v000005KGMN',
        digital: '00G1v000005NvE4',
      },
    },
  },
  'en-ca': {
    locale: 'en-ca',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_EN_CA_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENC1754062256384',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENC1754062256384/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G0Y000000T5kR',
        checkout: '00G07000000F1Ri',
        design: '00G07000000hD9M',
        digital: '00G1v000005NrXM',
        wedding: '00G07000000qlo5',
      },
    },
  },
  'en-gb': {
    locale: 'en-gb',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_UK_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWUKC1754738013522',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWUKC1754738013522/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxGP',
        checkout: '00G07000000i3PV',
        design: '00G1v00000550lC',
        digital: '00G41000000fxGP',
      },
    },
  },
  'en-ie': {
    locale: 'en-ie',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_EN_IE_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENI1747053180831',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENI1747053180831/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G0Y000000T6aA',
        checkout: '00G07000000F1Rj',
        design: '00G1v000007jkVU',
        digital: '00G0Y000000T6aA',
      },
    },
  },
  'en-nz': {
    locale: 'en-nz',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com/',
      eswConfigDevName: 'ChatAnywhere_MIAW_EN_NZ_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENN1744712578305',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENN1744712578305/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G0Y000000T6aCUAS',
        checkout: '00G07000000F1RkEAK',
        design: '00G1v000005KGMPEA4',
        digital: '00G1v000005NvE6EAK',
      },
    },
  },
  'en-sg': {
    locale: 'en-sg',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com/',
      eswConfigDevName: 'ChatAnywhere_MIAW_EN_SG_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENS1744692392992',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWENS1744692392992/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G07000000h2Ov',
        checkout: '00G07000000F1Rl',
        design: '00G07000000h8cq',
        digital: '00G07000000h2Ov',
      },
    },
  },
  'es-es': {
    locale: 'es-es',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_ES_ES_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWESE1749836076493',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWESE1749836076493/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxFH',
        checkout: '00G07000000F1Rm',
        design: '00G1v000007jkVT',
        digital: '00G41000000fxFH',
      },
    },
  },
  'es-us': {
    locale: 'es-us',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com/',
      eswConfigDevName: 'ChatAnywhere_MIAW_ES_US_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWESU1756114691498',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWESU1756114691498/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G0Y000000T6a9',
        checkout: '00G07000000F1Rn',
        design: '00G0Y000000T6a9',
        digital: '00G1v000007jYAe',
        msp: '00G07000000bKlk',
        ppag: '00G1v000005KMQw',
      },
    },
  },
  'fi-fi': {
    locale: 'fi-fi',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_FI_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWFIC1747652206619',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWFIC1747652206619/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G07000000h2Cn',
        checkout: '00G07000000F1Ro',
        design: '00G07000000hYBP',
        digital: '00G07000000h2Cn',
      },
    },
  },
  'fr-be': {
    locale: 'fr-be',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_FR_BE_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWFRB1753956457456',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWFRB1753956457456/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxFW',
        checkout: '00G07000000F1Rp',
        design: '00G07000000hUdO',
        digital: '00G41000000fxFW',
      },
    },
  },
  'fr-ca': {
    locale: 'fr-ca',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_FR_CA_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWFRC1754302277321',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWFRC1754302277321/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxFg',
        checkout: '00G07000000F1Rq',
        design: '00G07000000h9M9',
        digital: '00G41000000fxFg',
      },
    },
  },
  'fr-ch': {
    locale: 'fr-ch',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_FR_CH_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWFRC1749836204616',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWFRC1749836204616/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxFl',
        checkout: '00G07000000F1Rr',
        design: '00G07000000hEyh',
        digital: '00G41000000fxFl',
      },
    },
  },
  'fr-fr': {
    locale: 'fr-fr',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_FR_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWFRC1753716630478',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWFRC1753716630478/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fnFR',
        checkout: '00G07000000F1Rs',
        design: '00G1v00000550kx',
        digital: '00G41000000fnFR',
      },
    },
  },
  'it-ch': {
    locale: 'it-ch',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_IT_CH_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWITC1749835459478',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWITC1749835459478/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G0Y000000T6aB',
        checkout: '00G07000000F1Rt',
        design: '00G07000000hEyj',
        digital: '00G0Y000000T6aB',
      },
    },
  },
  'it-it': {
    locale: 'it-it',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_IT_IT_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWITI1749835338344',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWITI1749835338344/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxFv',
        checkout: '00G07000000F1Ru',
        design: '00G07000000hAnT',
        digital: '00G41000000fxFv',
      },
    },
  },
  'nb-no': {
    locale: 'nb-no',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_NO_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWNOC1747766368271',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWNOC1747766368271/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G07000000h2Co',
        checkout: '00G07000000F1Rx',
        design: '00G07000000hYBQ',
        digital: '00G07000000h2Co',
      },
    },
  },
  'nl-be': {
    locale: 'nl-be',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_NL_BE_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWNLB1749835927688',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWNLB1749835927688/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxG5',
        checkout: '00G07000000F1Rv',
        design: '00G07000000hUdP',
        digital: '00G41000000fxG5',
      },
    },
  },
  'nl-nl': {
    locale: 'nl-nl',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_NL_NL_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWNLN1749835555079',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWNLN1749835555079/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxG0',
        checkout: '00G07000000F1Rw',
        design: '00G07000000hUdQ',
        digital: '00G41000000fxG0',
      },
    },
  },
  'sv-se': {
    locale: 'sv-se',
    checkBusinessHour: true,
    sfConfig: {
      orgId: '00D410000007e46',
      scrt2URL: 'https://vpcare.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_SE_Chat',
      siteURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWSEC1747762414978',
      initURL: 'https://vpcare.my.site.com/ESWChatAnywhereMIAWSEC1747762414978/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G1v000007kdRF',
        checkout: '00G07000000F1Ry',
        design: '00G07000000hYBR',
        digital: '00G1v000007kdRF',
      },
    },
  },
};
export const getProdConfig = (locale: Locale): IChatConfigData => ({ ...prodConfigData[locale], env: 'production' });
